import { signal } from '@preact/signals';
import { apiOwnKeys } from 'mobx/dist/internal';

export const useIsMobileSignal = () => {
    const isMobile = signal(window.innerWidth <= 768);

    const updateIsMobile = () => {
        isMobile.value = window.innerWidth <= 768;
    };

    window.addEventListener('resize', updateIsMobile);

    return isMobile.value;
};
export const useGoogleMapsApiKey = () => {
    const apiKey = signal('AIzaSyBOuY82AgjNXo0nC-wBAz2iQJ8yv_jDdhk');
    return apiKey.value;
};
